export const isBankEnabled = (): boolean => {
  if (typeof window !== 'undefined') return !!window.envs?.bankEnabled && window.digiData.locale !== 'sv'
  return false
}
